import { Component, OnInit } from '@angular/core';
import { AddonService } from '../../services/addon/addon.service';
import { DataService } from '../../services/data/data.service';

@Component({
	selector: 'pcm-admin-addons',
	templateUrl: './admin-addons.component.html',
	styleUrls: ['./admin-addons.component.scss']
})
export class AdminAddonsComponent implements OnInit {

	title = 'Manage Add-Ons';

	constructor(
		public dataService: DataService,
		public addonService: AddonService
	) { }

	ngOnInit() {
		this.addonService.loadContractorAddons();
	}

	deleteField(event) {
		if (!event.field['isSaved']) {
			this.dataService.contractorAddonsEdited.splice(event.index, 1);
		} else {
			this.addonService.deleteContractorAddon(event.field);
		}
	}

	cancelEdits() {
		this.addonService.resetContractorAddons();
	}

}
